import { useEffect, useRef } from 'react';

function useInterval(fn, delay, options) {
  var immediate = options === null || options === void 0 ? void 0 : options.immediate;
  var timerRef = useRef();
  timerRef.current = fn;
  useEffect(function () {
    var _a;

    if (delay === undefined || delay === null) return;

    if (immediate) {
      (_a = timerRef.current) === null || _a === void 0 ? void 0 : _a.call(timerRef);
    }

    var timer = setInterval(function () {
      var _a;

      (_a = timerRef.current) === null || _a === void 0 ? void 0 : _a.call(timerRef);
    }, delay);
    return function () {
      clearInterval(timer);
    };
  }, [delay]);
}

export default useInterval;